module.exports = __webpack_public_path__ + "img/black-pattern-bg.3f6b524c.png";